export default "__VITE_ASSET__wZudhvKT__"